import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { goldDictVi } from "@/lib/shop/products/gold";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/vi/shop_/24kt-gold")({
  head: () => ({
    ...buildProductHead(goldDictVi),
    links: alternateLinkList("/shop/24kt-gold", "vi"),
  }),
  component: () => <ProductPage dict={goldDictVi} />,
});